//Jquery element animations on scroll

(function ($) {

  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

  jQuery.fn.visible = function (partial) {

    var $t = jQuery(this),
      $w = jQuery(window),
      viewTop = $w.scrollTop(),
      viewBottom = viewTop + $w.height(),
      _top = $t.offset().top,
      _bottom = _top + $t.height(),
      compareTop = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom;

    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
  };
  jQuery(window).scroll(function (event) {

    jQuery(".img-column").each(function (i, el, container) {
      var el = jQuery(el);
      var container = jQuery('.table-graphic-container');
      if (el.visible(true)) {
        container.addClass("visible");
      }
    });

  });

  jQuery('.teal-bg .quote-slides').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: 'linear',
    prevArrow: '<button type="button" class="slick-prev"><img src="/wp-content/themes/grayce/assets/images/teal-prev.svg" /></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="/wp-content/themes/grayce/assets/images/teal-next.svg" /></button>',
    responsive: [{

    }
    ]
  });
  jQuery('.purple-bg .quote-slides').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: 'linear',
    prevArrow: '<button type="button" class="slick-prev"><img src="/wp-content/themes/grayce/assets/images/purple-prev.svg" /></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="/wp-content/themes/grayce/assets/images/purple-next.svg" /></button>',
    responsive: [{

    }
    ]
  });
  jQuery('.feature-slides-on').slick({
    dots: false,
    infinite: true,
    speed: 500,
    cssEase: 'linear',
    fade: true,
    arrows: false,
    asNavFor: '.feature-slides-text-on',
    responsive: [{

    }
    ]
  });
  var $slideCount = jQuery('.slider-count');
  var $slickElement = jQuery('.feature-slides-text-on');
  $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $slideCount.text(i + ' of ' + slick.slideCount);
  });
  $slickElement.slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: 'linear',
    asNavFor: '.feature-slides-on',
    appendArrows: jQuery('.slider-arrows'),
    prevArrow: '<button type="button" class="slick-prev"><img src="/wp-content/themes/grayce/assets/images/purple-prev.svg" /></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="/wp-content/themes/grayce/assets/images/purple-next.svg" /></button>',
    responsive: [{

    }
    ]
  });
  jQuery('.stat-slider').slick({
    dots: false,
    infinite: true,
    speed: 700,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 5,
    slidesToScroll: 1,
    cssEase: 'ease-out',
    prevArrow: '<button type="button" class="slick-prev"><img src="/wp-content/themes/grayce/assets/images/light-purple-prev.svg" /></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="/wp-content/themes/grayce/assets/images/light-purple-next.svg" /></button>',
    responsive: [{
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }]
  });

  if (sessionStorage.getItem('alertSeen') != 'shown') {
    jQuery('.alert-bar').addClass('open');
  }
  if (sessionStorage.getItem('alertSeen') == 'shown') {
    jQuery('.alert-bar').removeClass('open');
  }
  jQuery('.alert-bar .close-button').click(function () {
    jQuery('.alert-bar').removeClass('open');
    sessionStorage.setItem('alertSeen', 'shown')
  });
  const test = sessionStorage.getItem('alertSeen');
  //console.log(test);

})(jQuery);

document.addEventListener('DOMContentLoaded', function () {
  const players = document.querySelectorAll('lottie-player.on-scroll');
  const anims = document.querySelectorAll('.growing-box');
  function playOnScroll() {
    const viewportHeight = window.innerHeight;
    players.forEach(function (player) {
      const playerTop = player.getBoundingClientRect().top;
      var lottie = player.closest('lottie-player');
        if (playerTop < viewportHeight * 0.5) {
             lottie.play();
        }
    });
    anims.forEach(function (anim) {
      const animTop = anim.getBoundingClientRect().top;
      if(animTop < viewportHeight * 0.9) {
        anim.classList.add('animate');
      }
    })
  }
  window.addEventListener('scroll', playOnScroll);
  playOnScroll();
});


// Cache selection
var $window = jQuery(window);

// Debounce function
function debounce(fn, delay) {
  let timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, arguments);
    }, delay);
  }
}

// Resize handler
function handleResize() {
  var windowWidth = $window.width();
  if (windowWidth > 0) {
    var containerHeight = windowWidth / 2;
    jQuery('.right-background').css('height', containerHeight);
  }

  if (windowWidth > 1295) {
    var marginBlockStart = (windowWidth - 1296) / 2;
    jQuery('.new-hero-text').css('margin-left', marginBlockStart);
  }
}

const debounceHandleResize = debounce(handleResize, 100);

$window.resize(debounceHandleResize);

handleResize();

jQuery('.accordion-item a').click(function () {
  var $this = jQuery(this);
  var id = $this.attr('data-image-link');
  var $currentImg = jQuery('[id="' + id + '"]'); // use attribute equals selector

  // Remove 'is-active' class from all images
  jQuery('.img-container').removeClass('is-active');

  // Add 'is-active' class to the current image
  $currentImg.addClass('is-active');
});



function addClassToMatchingHref() {
  const currentHash = window.location.hash;

  const anchorTags = document.querySelectorAll('a');

  anchorTags.forEach(function (anchor) {
    if (anchor.getAttribute('href') === currentHash) {
      anchor.classList.add('is-active');
    } else {
      anchor.classList.remove('is-active');
    }
  });
}

addClassToMatchingHref();

window.addEventListener('hashchange', addClassToMatchingHref);


document.addEventListener("DOMContentLoaded", function() {
  // Check if the current page is not /buy
  if (window.location.pathname !== '/buy') {
      // Check if the screen size is 767px or less
      if (window.innerWidth <= 767) {
          // Select all h2 elements within .elementor-kit-460
          var elements = document.querySelectorAll('.elementor-kit-460 h2');
          // Apply the font-size: unset style
          elements.forEach(function(element) {
              element.style.fontSize = '26px';
          });
      }
  }
});

window.addEventListener('resize', function() {
  if (window.location.pathname !== '/buy' && window.innerWidth <= 767) {
      var elements = document.querySelectorAll('.elementor-kit-460 h2');
      elements.forEach(function(element) {
          element.style.fontSize = '26px';
      });
  }
});
